import { render, staticRenderFns } from "./viewRequiredCandidateDocs.vue?vue&type=template&id=7ff5f3f2&scoped=true&"
import script from "./viewRequiredCandidateDocs.vue?vue&type=script&lang=js&"
export * from "./viewRequiredCandidateDocs.vue?vue&type=script&lang=js&"
import style0 from "./viewRequiredCandidateDocs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./viewRequiredCandidateDocs.vue?vue&type=style&index=1&id=7ff5f3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff5f3f2",
  null
  
)

export default component.exports